import { DeepProfileApiRequest, DeepProfileDownloadRequest, DeepProfileFull, DeepProfileToReport } from "types";

import API from "api/client";
import { downloadFileWithoutPopup } from "utils/download/downloadFile";
import { envConfig } from "config";

const { deepProfilesAPI } = envConfig;

/**
 * Creates a new Deep Profile with the provided settings and groups
 */
const createDeepProfile = (req: DeepProfileApiRequest): Promise<DeepProfileFull> => {
  return API.post<DeepProfileFull>(`${deepProfilesAPI}`, req).then((res) => res.data);
};

/**
 * Gets a Deep Profile and its groups
 */
const getDeepProfile = (uuid: string): Promise<DeepProfileFull> => {
  return API.get<DeepProfileFull>(`${deepProfilesAPI}${uuid}`).then((res) => res.data);
};

/**
 * Updates a Deep Profile with the provided settings and groups
 */
const updateDeepProfile = (uuid: string, req: DeepProfileApiRequest): Promise<DeepProfileFull> => {
  return API.put<DeepProfileFull>(`${deepProfilesAPI}${uuid}`, req).then((res) => res.data);
};

/**
 * Soft deletes deep profile with uuid
 */
const deleteDeepProfile = (uuid: string): Promise<void> => {
  return API.delete<void>(`${deepProfilesAPI}${uuid}`).then((res) => res.data);
};

/**
 * Initiate a report computation of the deep profile.  A report file will be generated
 * asynchrously in aws
 */
const computeDeepProfile = async (uuid: string): Promise<void> => {
  await API.post(`${deepProfilesAPI}${uuid}/compute`);
};

/**
 * Get a temporary url for downloading a deep profile report from s3
 */
const downloadDeepProfile = async ({ uuid, reportId }: DeepProfileDownloadRequest): Promise<void> => {
  const { data } = await API.get<string>(`${deepProfilesAPI}${uuid}/report/${reportId}`);
  downloadFileWithoutPopup(data);
};

/**
 * Get a list of all reports associated with a deep profile
 */
const getDeepProfileReports = ({ uuid }: { uuid: string }): Promise<DeepProfileToReport[]> => {
  return API.get<DeepProfileToReport[]>(`${deepProfilesAPI}${uuid}/reports`).then((res) => res.data);
};

export default {
  create: createDeepProfile,
  get: getDeepProfile,
  update: updateDeepProfile,
  delete: deleteDeepProfile,
  compute: computeDeepProfile,
  download: downloadDeepProfile,
  listReports: getDeepProfileReports,
};
